<div class="container">
  <agr-notification-empty class="wrapper--fixed">
    <mat-tab-group
      (selectedIndexChange)="tabChange($event)"
      headerPosition="above"
      class="mat-tab-group mat-primary ng-star-inserted"
    >
      <mat-tab
        label="{{ 'my-dashboard.tab-header-offers' | translate }} ({{
          totalNumberOfActiveOffers$ | async
        }})"
        class="mat-tab-header"
      >
        <div
          aria-hidden="true"
          mat-ripple
          class="mat-ripple mat-tab-header-pagination mat-tab-header-pagination-before mat-elevation-z4 mat-tab-header-pagination-disabled"
        >
          <div class="mat-tab-header-pagination-chevron"></div>
        </div>
      </mat-tab>
      <mat-tab
        label="{{ 'my-dashboard.tab-header-requests' | translate }} ({{
          totalNumberOfActiveRequests$ | async
        }})"
        class="mat-tab-header"
      >
        <div
          aria-hidden="true"
          mat-ripple
          class="mat-ripple mat-tab-header-pagination mat-tab-header-pagination-before mat-elevation-z4 mat-tab-header-pagination-disabled"
        >
          <div class="mat-tab-header-pagination-chevron"></div>
        </div>
      </mat-tab>
    </mat-tab-group>
  </agr-notification-empty>
</div>
